import React from 'react';
import PropTypes from 'prop-types';

import { renderHTMLString } from '../../../../../helpers';

import './AgendaSpeakers.scss';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';

export default function AgendaSpeakers(props) {
  const { speakers = [], agendaType = 'list' } = props;
  const { location } = useRootSelector(selectPageConfig);

  return (
    <div className="row">
      <ul
        className={`col-xs-12 agenda-item-speakers agenda-item-speakers--${agendaType}`}
      >
        {speakers.map((item, index) => {
          const { title, jobTitle = '', company = '' } = item;
          return (
            <li key={index}>
              <strong className="speaker-name">
                {renderHTMLString(title, location)}
              </strong>
              {jobTitle.length > 0 && (
                <span className="speaker-job-title">
                  {' - '}
                  {renderHTMLString(jobTitle, location)}
                </span>
              )}
              {company.length > 0 && (
                <span className="speaker-job-company">
                  {', '}
                  {renderHTMLString(company, location)}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

AgendaSpeakers.propTypes = {
  speakers: PropTypes.array,
  agendaType: PropTypes.string,
};
